module.exports = __webpack_public_path__ + "media/img/frontend_application/bulb-706f5eaab649decf9f0b7cd32335d99e.png";